import * as React from 'react';
import Overstep from './Overstep';
import { OverstepPageProvider } from '@ids/context/OverstepPage';

function OverstepPage() {
    return (
        <OverstepPageProvider>
            <Overstep data-testid="ids-overstep-page" />
        </OverstepPageProvider>
    );
}

export default OverstepPage;
